// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenuOutlined, UserOutlined, LogoutOutlined, SettingOutlined, DownOutlined, BankOutlined } from '@ant-design/icons';
import { Select, Dropdown } from 'antd';
import { api } from '../services/api';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import './Header.css';

const Header = ({ onToggleSidebar }) => {
  const { t } = useTranslation();
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();
  const [user, setUser] = useState({ name: t('header.defaultUser'), isadmin: 0 });
  const [company, setCompany] = useState('嘉兴吉晟电力');

  useEffect(() => {
    const saved = localStorage.getItem('currentUser');
    if (saved) {
      try {
        setUser(JSON.parse(saved));
      } catch (e) { /* ignore */ }
    }
    const savedCompany = localStorage.getItem('currentCompany');
    if (savedCompany) {
      // 兼容历史数据：currentCompany 可能被存成 JSON 对象
      try {
        const o = JSON.parse(savedCompany);
        setCompany(typeof o === 'string' ? o : (o.name || o.short || savedCompany));
      } catch (e) { setCompany(savedCompany); }
    }

    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    const weeks = [t('admin.sunday'), t('admin.monday'), t('admin.tuesday'), t('admin.wednesday'), t('admin.thursday'), t('admin.friday'), t('admin.saturday')];
    const y = date.getFullYear();
    const mo = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${y}-${mo}-${d} ${h}:${mi}:${s} ${weeks[date.getDay()]}`;
  };

  const handleLogout = async () => {
    try {
      const saved = localStorage.getItem('currentUser');
      if (saved) {
        const { id, name } = JSON.parse(saved);
        await api.logout({ userId: id, username: name });
      }
    } catch (e) { /* ignore */ }
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('loginIp');
    navigate('/');
  };

  const handleCompanyChange = (value) => {
    setCompany(value);
    localStorage.setItem('currentCompany', value);
  };

  // 评审 41：顶栏不再显示页面名称（页面名称与面包屑统一由页面内呈现）

  const roleText = user.isadmin === 2 ? t('header.superAdmin')
    : user.isadmin === 1 ? t('header.admin')
      : user.company_admin ? '公司管理员' : t('header.user');

  // 缺陷158：顶栏与门户页的用户菜单保持同一套入口，「设置中心」统一进入门户设置中心
  const userMenu = {
    items: [
      { key: 'profile', icon: <UserOutlined />, label: '个人中心', onClick: () => navigate('/portal/profile') },
      { key: 'settings', icon: <SettingOutlined />, label: '设置中心', onClick: () => navigate('/portal/settings') },
      { key: 'admin', icon: <SettingOutlined />, label: '进入后台', onClick: () => navigate('/app/admin/station') },
      { type: 'divider' },
      { key: 'logout', icon: <LogoutOutlined />, label: t('header.logout'), onClick: handleLogout },
    ],
  };

  return (
    <div className="app-header">
      <div className="header-left">
        <button className="hamburger-btn" onClick={onToggleSidebar}>
          <MenuOutlined />
        </button>
        <div className="header-title-bar" />
        <div className="time-location">
          <span className="time">{formatDate(currentTime)}</span>
        </div>
      </div>
      <div className="header-right">
        <Select
          className="header-company"
          value={company}
          onChange={handleCompanyChange}
          size="small"
          suffixIcon={<BankOutlined />}
          options={[
            // 当前登录公司不在演示公司列表中时，作为额外选项展示，避免顶栏显示原始值
            ...(company && !['嘉兴吉晟电力', '杭州储能科技'].includes(company)
              ? [{ value: company, label: company }] : []),
            { value: '嘉兴吉晟电力', label: '嘉兴吉晟电力' },
            { value: '杭州储能科技', label: '杭州储能科技' },
          ]}
        />
        <Select
          value={i18n.language}
          onChange={(lang) => i18n.changeLanguage(lang)}
          style={{ width: 96 }}
          size="small"
          options={[
            { value: 'zh', label: '中文' },
            { value: 'en', label: 'English' },
            { value: 'th', label: 'ภาษาไทย' },
          ]}
        />
        <Dropdown menu={userMenu} placement="bottomRight" trigger={['click']}>
          <div className="header-user">
            <UserOutlined />
            <span>{user.name || t('header.defaultUser')}</span>
            <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11 }}>{roleText}</span>
            <DownOutlined style={{ fontSize: 10 }} />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default Header;